"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var FIELD;
(function (FIELD) {
    FIELD[FIELD["BEFORE"] = 0] = "BEFORE";
    FIELD[FIELD["HOUR"] = 1] = "HOUR";
    FIELD[FIELD["MINUTE"] = 2] = "MINUTE";
    FIELD[FIELD["AMPM"] = 3] = "AMPM";
    FIELD[FIELD["AFTER"] = 4] = "AFTER";
})(FIELD = exports.FIELD || (exports.FIELD = {}));
exports.BLANK = '--';
exports.NULL_TIME = exports.BLANK + ":" + exports.BLANK;
var AmPmOptions;
(function (AmPmOptions) {
    AmPmOptions["None"] = "none";
    AmPmOptions["Lowercase"] = "lowercase";
    AmPmOptions["Uppercase"] = "uppercase";
    AmPmOptions["Capitalized"] = "capitalized";
})(AmPmOptions = exports.AmPmOptions || (exports.AmPmOptions = {}));
exports.AmPmStrings = (_a = {},
    _a[AmPmOptions.Lowercase] = { am: 'am', pm: 'pm' },
    _a[AmPmOptions.Uppercase] = { am: 'AM', pm: 'PM' },
    _a[AmPmOptions.Capitalized] = { am: 'Am', pm: 'Pm' },
    _a);
//# sourceMappingURL=constants.js.map